module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/surgical-7c377c5891c15b1000afaada26c3bfbb.svg";